/*
  Indicador de scroll de la fila de subcategorias
  ------------------------------------------------------------
  La fila scrollea horizontal pero no tiene barra (`scrollbar-width: none`) ni
  flechas, asi que la unica pista de que hay mas categorias era que la ultima
  visible quedaba cortada a mitad de palabra. El degradado del borde derecho lo
  dice de entrada.

  El degradado no puede ir siempre puesto:

  - con pocas subcategorias no hay nada que scrollear y la ultima palabra saldria
    difuminada sin motivo, que se lee como un bug de render;
  - al llegar al final tampoco corresponde, porque ya no hay nada mas a la derecha.

  Por eso el CSS cuelga de dos atributos y este archivo es el que los escribe.
  Se remide en `resize`, con un `ResizeObserver` sobre la lista y en
  `document.fonts.ready`: el ancho de los links se asienta despues del layout, y
  medir antes daria `scrollWidth == clientWidth` en una fila que si desborda.
*/
(() => {
  const END_SLACK = 2; // el scroll fraccionario no siempre cierra en el entero

  const sync = (el) => {
    const scrollable = el.scrollWidth - el.clientWidth > END_SLACK;
    el.setAttribute('data-scrollable', scrollable ? '1' : '0');
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - END_SLACK;
    el.setAttribute('data-scroll-end', scrollable && atEnd ? '1' : '0');
  };

  const bind = (el) => {
    if (el.dataset.subcollBound === '1') return;
    el.dataset.subcollBound = '1';
    sync(el);
    el.addEventListener('scroll', () => sync(el), { passive: true });

    const list = el.querySelector('.plp-subcollections__list');
    if (list && 'ResizeObserver' in window) {
      new ResizeObserver(() => sync(el)).observe(list);
    }
  };

  const initAll = () => document.querySelectorAll('.plp-subcollections__inner').forEach(bind);

  initAll();
  window.addEventListener('resize', () =>
    document.querySelectorAll('.plp-subcollections__inner').forEach(sync)
  );
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() =>
      document.querySelectorAll('.plp-subcollections__inner').forEach(sync)
    );
  }
  document.addEventListener('shopify:section:load', initAll);
})();
